export const visit = (vm, at) => {
vm(require("timezone-utils/lang/ko.lyaml"));
vm(require("ui-addon-i18n/lang/ko.lyaml"));
vm(require("UIComponents/lang/ko.lyaml"));
vm(require("MeetingsLib/lang/ko.lyaml"));
vm(require("sanitize-text/lang/ko.lyaml"));
vm(require("I18n/lang/ko.lyaml"));
at({ "ko": { "placeholderString": "\uBBF8\uD305" } });
};